import { useQuery } from '@tanstack/react-query'
import { get } from 'src/utils/http'
import { Org } from './useOrg'
import useAuth from './useAuth'

const useOrgs = (): {
  orgs?: Org[]
  isLoading: boolean
} => {
  const { isLoggedIn, isLoading: isAuthLoading } = useAuth()

  const { data: orgs, isFetching } = useQuery<Org[]>(
    ['users/orgs'],
    () => get(`users/orgs`),
    {
      enabled: !isAuthLoading && isLoggedIn,
    },
  )

  return {
    orgs,
    isLoading: isFetching,
  }
}

export default useOrgs
